var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalcreditvalue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.5,
    r: 30,
    fill: "#EB5757",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 22.7V24.5H16.2C15.4839 24.5 14.7972 24.7845 14.2908 25.2908C13.7845 25.7972 13.5 26.4839 13.5 27.2V39.8C13.5 40.5161 13.7845 41.2028 14.2908 41.7092C14.7972 42.2155 15.4839 42.5 16.2 42.5H40.8C41.1546 42.5 41.5057 42.4302 41.8332 42.2945C42.1608 42.1588 42.4585 41.9599 42.7092 41.7092C42.9599 41.4585 43.1588 41.1608 43.2945 40.8332C43.4302 40.5057 43.5 40.1546 43.5 39.8V38H45.3C46.788 38 48 36.788 48 35.3V22.7C48 21.212 46.788 20 45.3 20H20.7C19.212 20 18 21.212 18 22.7ZM21 23V24.5H40.8C41.1546 24.5 41.5057 24.5698 41.8332 24.7055C42.1608 24.8412 42.4585 25.0401 42.7092 25.2908C42.9599 25.5415 43.1588 25.8392 43.2945 26.1668C43.4302 26.4943 43.5 26.8454 43.5 27.2V35H45V23H21ZM25.5 33.5C25.5 32.7044 25.8161 31.9413 26.3787 31.3787C26.9413 30.8161 27.7044 30.5 28.5 30.5C29.2956 30.5 30.0587 30.8161 30.6213 31.3787C31.1839 31.9413 31.5 32.7044 31.5 33.5C31.5 34.2956 31.1839 35.0587 30.6213 35.6213C30.0587 36.1839 29.2956 36.5 28.5 36.5C27.7044 36.5 26.9413 36.1839 26.3787 35.6213C25.8161 35.0587 25.5 34.2956 25.5 33.5Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalcreditvalue);
export default __webpack_public_path__ + "static/media/totalcreditvalue.de151211e841edac382b0a025e0b49b6.svg";
export { ForwardRef as ReactComponent };